module.exports = __webpack_public_path__ + "asc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/asc.svg?color1=%23333333&color2=
// module id = 908
// module chunks = 67